import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {PageNotFoundComponent} from './shared/page-not-found/page-not-found.component';
import {LoginComponent} from './core/login/login.component';
import {LandingComponent} from './core/landing/landing.component';
import {AuthGuard} from './core/auth.guard';
import {ResetPasswordComponent} from './core/reset-password/reset-password.component';
import {ForceChangePasswordComponent} from './core/force-change-password/force-change-password.component';
import {SettingsComponent} from './core/settings/settings.component';
import {CanUpdatePermissionsGuard} from './core/can-update-permissions.guard';


const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  {
    path: 'force-change-password',
    component: ForceChangePasswordComponent,
    pathMatch: 'full',
  },
  {
    path: 'permissions',
    component: SettingsComponent, canActivate: [AuthGuard, CanUpdatePermissionsGuard],
    pathMatch: 'full',
  },
  {
    path: 'public-form',
    loadChildren: () => import('./visits/forms/public-form/public-form-routing.module').then(m => m.PublicFormRoutingModule),
  },
  {
    path: 'job-offer/:id',
    loadChildren: () => import('./stores/job-offer/job-offer.module').then(m => m.JobOfferModule),
  },
  { path: 'home', component: LandingComponent, canActivate: [AuthGuard] },
  { path: 'page-not-found', component: PageNotFoundComponent },
  { path: 'users', loadChildren: () => import('./users/users.module').then(m => m.UsersModule) },
  { path: 'stores', loadChildren: () => import('./stores/stores.module').then(m => m.StoresModule) },
  { path: 'imports', loadChildren: () => import('./imports/imports.module').then(m => m.ImportsModule) },
  { path: 'calendar', loadChildren: () => import('./calendar/calendar.module').then(m => m.CalendarModule) },
  { path: 'batches', loadChildren: () => import('./batches/batches.module').then(m => m.BatchesModule) },
  { path: 'reporting',  loadChildren: () => import('./reporting/reports.module').then(m => m.ReportsModule) },
  { path: 'viba/agent', loadChildren: () => import('./viba/agents/agents.module').then(m => m.AgentsModule) },
  { path: 'viba/admin', loadChildren: () => import('./viba/admin/viba-admin.module').then(m => m.VibaAdminModule) },
  { path: 'microsite-builder', loadChildren: () => import('./microsite_builder/microsite-builder-page.module').then(m => m.MicrositeBuilderPageModule) },
  { path: 'visits', loadChildren: () => import('./visits/visits.module').then(m => m.VisitsModule) },
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: '**', redirectTo: 'page-not-found' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
